import TemperatureRange from './components/TemperatureRange';
import DateRangePicker from './components/DateRangePicker';
import ShipmentsTable from './components/ShipmentsTable';
import ShadowInput from './components/ShadowInput';
import DatePicker from './components/DatePicker';
import Dashboard from './components/Dashboard';
import Drawer from './components/Drawer';
import FormDrawer from './components/FormDrawer';
import TimezoneDrawer from './components/TimezoneDrawer';
import Select from './components/Select';
import Tabs from './components/Tabs';

declare var $: any;

$(document).ready(function () {
  if (/MSIE|Trident/.test(window.navigator.userAgent)) {
    document.body.style.overflow = 'hidden';

    (document.querySelector('.tc-not-supported') as HTMLElement).style.display = 'block';

    return;
  }

  const selects = [];

  if (document.querySelector('.tc-select-dropdown')) {
    [].slice.call(document.querySelectorAll('.tc-select-dropdown')).forEach(($select: HTMLSelectElement) => {
      const id = $select.getAttribute('id');
      selects[id] = new Select($select);
    });
  }

  // listen for the tc:reinitializeSelect event
  document.addEventListener('tc:reinitializeSelect', (event: CustomEvent) => {
    const { selectId } = event.detail;
    const select = document.querySelector(`#${selectId}`) as HTMLSelectElement;

    if (select) {
      new Select(select as HTMLSelectElement);
    }
  });

  const $sideNav = document.querySelector('.tc-sidenav') as HTMLElement;
  const $navbar = document.querySelector('.tc-navbar') as HTMLElement;

  if (window.innerWidth >= 992) {
    $navbar.style.width = `${window.innerWidth - 90 - (window.innerWidth - document.documentElement.clientWidth)}px`;
  } else {
    $navbar.style.width = `${window.innerWidth - (window.innerWidth - document.documentElement.clientWidth)}px`;
  }

  $sideNav.style.height = `${window.innerHeight}px`;

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 992) {
      $navbar.style.width = `${window.innerWidth - 90 - (window.innerWidth - document.documentElement.clientWidth)}px`;
    } else {
      $navbar.style.width = `${window.innerWidth - (window.innerWidth - document.documentElement.clientWidth)}px`;
    }

    $sideNav.style.height = `${window.innerHeight}px`;
  });

  window.addEventListener('load', function() {
    [].slice.call(document.querySelectorAll('form.needs-validation')).forEach(($form: HTMLFormElement) => {
      $form.addEventListener('submit', function(event) {
        if (!$form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        $form.classList.add('was-validated');
      }, false);
    });
  }, false);

  document.querySelectorAll<HTMLElement>('.tc-tabs').forEach(($tabs) => {
    new Tabs($tabs);
  });

  if (document.querySelector('.tc-tab-bar')) {
    new Drawer(document.querySelector('.tc-tab-bar__item.is-more'), document.querySelector('.tc-drawer#tab-bar-more'));
  }

  if (document.querySelector('.tc-dashboard')) {
    new Dashboard();
  }

  if (document.querySelector('.tc-shipments__table')) {
    new ShipmentsTable();
  }

  if (document.querySelector('.tc-shipment-dates')) {
    new DateRangePicker('.tc-shipment-dates');
  }

  if (document.querySelector('.tc-temperature-range')) {
    new TemperatureRange();
  }

  if (document.querySelector('.tc-date-picker')) {
    new DatePicker('.tc-date-picker');
  }

  if (!window.matchMedia('( pointer: coarse )').matches) {
    if (document.querySelector('.tc-date-input')) {
      $('.tc-date-input').inputmask('datetime', {
        clearMaskOnLostFocus: false,
        placeholder: 'DD-MM-YYYY',
        inputFormat: 'dd-mm-yyyy',
        insertMode: true,
        alias: 'datetime',
      });
    }

    if (document.querySelector('.tc-date-input-optional')) {
      $('.tc-date-input-optional').inputmask('datetime', {
        clearMaskOnLostFocus: true,
        placeholder: 'DD-MM-YYYY',
        inputFormat: 'dd-mm-yyyy',
        insertMode: true,
        alias: 'datetime',
      });
    }

    if (document.querySelector('.tc-time-input')) {
      $('.tc-time-input').inputmask('datetime', {
        clearMaskOnLostFocus: false,
        placeholder: 'HH:MM',
        inputFormat: 'HH:MM',
        insertMode: true,
        hourFormat: 24,
        alias: 'datetime',
      });
    }
  }

  if (document.querySelector('.tc-temperature-input')) {
    $('.tc-temperature-input').inputmask('[\\-]9{1,2}[(.)|(,)9{1}]', {
      placeholder: '',
    });
  }

  if (document.querySelector('.modal#comment-modal')) {
    $('.modal#comment-modal').on('shown.bs.modal', function () {
      [].slice.call(document.querySelectorAll('.modal#comment-modal input[data-shadow-input]')).forEach(($input: HTMLInputElement) => {
        const $shadow = document.querySelector(`.modal#comment-modal input${$input.getAttribute('data-shadow-input')}`) as HTMLInputElement;

        $shadow.style.height = `${$input.clientHeight}px`;
        $shadow.style.width = `${$input.clientWidth}px`;
        $shadow.style.left = `${$input.offsetLeft}px`;
        $shadow.style.top = `${$input.offsetTop}px`;
      });
    });

    $('.modal#comment-modal').on('hidden.bs.modal', function () {
      const $form = $(this).find('form')[0];

      $($form).removeClass('was-validated');
      $form.reset();
    });
  }

  if (document.querySelector('input[data-shadow-input]')) {
    new ShadowInput();
  }

  if (document.querySelector('.tc-form-drawer.is-comment-drawer-edit')) {
    window['mobileEditCommentFormDrawer'] = new FormDrawer(null, document.querySelector('.tc-form-drawer.is-comment-drawer-edit'));
  }

  if (document.querySelector('.tc-form-drawer.is-comment-drawer')) {
    window['mobileCommentFormDrawer'] = new FormDrawer(document.querySelector('.tc-comment-mobile'), document.querySelector('.tc-form-drawer.is-comment-drawer'));
  }

  if (document.querySelector('.tc-shipment-timezone-mobile')) {
    new TimezoneDrawer(
      document.querySelector('.tc-shipment-timezone-mobile'),
      document.querySelector('.tc-form-drawer.is-timezone-drawer'),
      document.querySelector('select.tc-shipment-timezone__select'),
    );
  }
});
